// src/GlobalContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getApiBaseUrl } from "../../utils/apiAssetUrl";
import { useDisclosure } from '@chakra-ui/react';
import GlobalAppLoader from '../GlobalAppLoader';

const GlobalContext = createContext();

/** Brief minimum so the loader is visible (avoids sub-ms flash on fast networks). */
const MIN_BOOTSTRAP_LOADER_MS = 520;

export const GlobalProvider = ({ children }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isModal1Open, onOpen: openModal1, onClose: closeModal1 } = useDisclosure();
    const [cart, setCart] = useState([]);
    const [totalCartItem, setTotalCartItem] = useState(0);
    const [totalhandle, setTotalHandle] = useState(0);
    const [totaldelivery, setTotalDelivery] = useState([]);
    const [cod, setCod] = useState(0);
    const [Admobile, setAdMobile] = useState("");
    const [whatsappNo, setWhastappNo] = useState("");
    const [appBootstrapReady, setAppBootstrapReady] = useState(false);
    const [globalLoadCount, setGlobalLoadCount] = useState(0);

    const beginGlobalLoad = useCallback(() => {
        setGlobalLoadCount((c) => c + 1);
    }, []);

    const endGlobalLoad = useCallback(() => {
        setGlobalLoadCount((c) => Math.max(0, c - 1));
    }, []);

    const fetchCartData = async () => {
        try {
            const loginRaw = JSON.parse(localStorage.getItem("login")) || "";
            const pid = loginRaw?.permanent_ID;
            if (!pid) {
                setCart([]);
                setTotalCartItem(0);
                setCod(undefined);
                return;
            }
            const base = getApiBaseUrl();
            const response = await fetch(`${base}/cart/${pid}`);
            const res = await response.json();
            const list = Array.isArray(res) ? res : [];
            const parsedCart = list.map((item) => ({
                ...item,
                product: JSON.parse(item.product || "{}"),
            }));
            setTotalCartItem(parsedCart.length);
            setCart(parsedCart);
            setCod(parsedCart[0]?.cod);
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    const handlingChargedata = async () => {
        try {
            const base = getApiBaseUrl();
            const response = await fetch(`${base}/handling-charge`);
            const res = await response.json();
            setTotalHandle(res.data[0].handling_price);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchMobileData = async () => {
        try {
            const base = getApiBaseUrl();
            const response = await fetch(`${base}/admin-mobile`);
            if (!response.ok) return;
            const result = await response.json();
            setWhastappNo(result.data.whatsAppNo);
            setAdMobile(result.data.mobile);
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const DeliveryChargedata = async () => {
        try {
            const base = getApiBaseUrl();
            const response = await fetch(`${base}/deliverym-charge`);
            const res = await response.json();
            setTotalDelivery(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        let cancelled = false;
        const started = Date.now();

        const run = async () => {
            await Promise.allSettled([
                fetchCartData(),
                handlingChargedata(),
                DeliveryChargedata(),
                fetchMobileData(),
            ]);
            if (cancelled) return;
            const elapsed = Date.now() - started;
            if (elapsed < MIN_BOOTSTRAP_LOADER_MS) {
                await new Promise((r) => setTimeout(r, MIN_BOOTSTRAP_LOADER_MS - elapsed));
            }
            if (!cancelled) setAppBootstrapReady(true);
        };

        run();
        return () => {
            cancelled = true;
        };
    }, []);

    const showGlobalLoader = !appBootstrapReady || globalLoadCount > 0;

    return (
        <GlobalContext.Provider
            value={{
                isOpen,
                onOpen,
                onClose,
                isModal1Open,
                openModal1,
                closeModal1,
                fetchCartData,
                cart,
                totalCartItem,
                totaldelivery,
                setTotalDelivery,
                totalhandle,
                Admobile,
                whatsappNo,
                cod,
                beginGlobalLoad,
                endGlobalLoad,
                appBootstrapReady,
            }}
        >
            {children}
            <GlobalAppLoader visible={showGlobalLoader} />
        </GlobalContext.Provider>
    );
};

export const useGlobalContext = () => useContext(GlobalContext);
